<template>
    <div class="block xl:flex flex-row gap-x-6 xl:pr-8">

        <div>
            <h2 class="mb-2">Billing Address</h2>

            <div class="flex gap-x-4 justify-between items-end mb-4">
                <div class="flex-1">
                    <jet-label for="first_name" value="First Name" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.first_name" ref="first_name" required />
                    <jet-input-error :message="$page.props.errors.first_name" class="m-1" />
                </div>
                <div class="flex-1">
                    <jet-label for="last_name" value="Last Name" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.last_name" ref="last_name" required />
                    <jet-input-error :message="$page.props.errors.last_name" class="m-1" />
                </div>
            </div>

            <div class="mb-4">
                <div class="flex-1">
                    <jet-label for="phone" value="Phone" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.phone" ref="phone"  required />
                    <jet-input-error :message="$page.props.errors.phone" class="m-1" />
                </div>
            </div>

            <div class="flex gap-x-4 justify-between items-end mb-4">
                <div class="flex-1">
                    <jet-label for="street_number" value="Street Number" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.street_number" ref="street_number" required />
                    <jet-input-error :message="$page.props.errors.street_number" class="m-1" />
                </div>
                <div class="flex-1">
                    <jet-label for="street_name" value="Street Name" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.street_name" ref="street_name" required />
                    <jet-input-error :message="$page.props.errors.street_name" class="m-1" />
                </div>
                <div class="flex-1">
                    <jet-label for="postal" value="Postal Code" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.postal" ref="postal" required />
                    <jet-input-error :message="$page.props.errors.postal" class="m-1" />
                </div>
            </div>

            <div class="flex gap-x-4 justify-between items-end mb-4">
                <div class="flex-1">
                    <jet-label for="city" value="City" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.city" ref="city" required />
                    <jet-input-error :message="$page.props.errors.city" class="m-1" />
                </div>
            </div>

            <div class="mb-4">
                <div>
                    <jet-label for="province" value="Province" class="w-32 align-top leading-7 whitespace-nowrap" />
                    <div class="flex flex-1 flex-col">
                       <multiselect 
                            class="multi-lg h-7 text-base"
                            v-model="form.province"
                            :options="provinceOptions"
                            :canClear="false"
                            :canDeselect="false"
                        />
                        <jet-input-error :message="$page.props.errors.province" class="m1" />
                    </div>
                </div>
            </div>
        </div>

        <div class="xl:pl-8 my-8 xl:mt-0 w-full xl:w-1/3 xl:border-l border-gray">
            <h2 class="mb-2">Card Details</h2>

            <div v-if="form.id" class="text-xs mb-4">If the credit card number has changed, remove this card and add a new one.</div>

            <div class="mb-4">
                <div class="flex-1">
                    <jet-label for="last_four" value="Card Number" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.last_four" ref="last_four" :disabled="form.id" />
                    <jet-input-error :message="$page.props.errors.last_four" class="m-1" />
                </div>
            </div>
            <div class="mb-4">
                <div class="flex-1">
                    <jet-label for="expiry" value="Expiry (MMYY)" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.expiry" ref="expiry" />
                    <jet-input-error :message="$page.props.errors.expiry" class="m-1" />
                </div>
            </div>
            <div class="mb-4">
                <div class="flex-1">
                    <jet-label for="cvd" value="CVC" class="" />
                    <jet-input type="text" class="block w-full" v-model="form.cvd" ref="cvd" />
                    <jet-input-error :message="$page.props.errors.cvd" class="m-1" />
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import JetLabel from '@/Jetstream/Label';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError.vue';
import Multiselect from '@vueform/multiselect';
import Toggle from '@vueform/toggle';

export default {
    props: [
        'form',
    ],

    components: {
        JetLabel,
        JetInput,
        JetInputError,
        Multiselect,
        Toggle,
    },

    setup () {
    },

    data() {
        return {
            provinceOptions: [
                'Ontario',
                'Manitoba',
                'Saskatchewan',
                'British Columbia',
                'Yukon',
                'Northwest Territories',
                'Nunavut',
                'Quebec',
                'Nova Scotia',
                'New Brunswick',
                'Newfoundland',
                'Prince Edward Island'
            ]
        }
    },
}
</script>

<style>

</style>
